import {
  MessageSquare,
  PlusCircle,
  FolderKanban,
  Bot,
  Users,
  Wrench,
  Workflow,
  Sparkles,
  BarChart3,
  Crown,
} from 'lucide-react';

/** Primary sidebar nav — paths match existing app routes. */
export const NavData = [
  { path: 'chat', name: 'ARI Chat', icon: MessageSquare },
  { path: 'create-agent', name: 'Create Agent', icon: PlusCircle },
  { path: 'projects', name: 'Projects', icon: FolderKanban },
  { path: 'agents', name: 'Agents', icon: Bot },
  { path: 'team', name: 'Team', icon: Users },
  { path: 'tools', name: 'Tools', icon: Wrench },
  { path: 'skills', name: 'Skills', icon: Sparkles },
  { path: 'workflows', name: 'Workflows', icon: Workflow },
];

export const SecondaryNavData = [
  { path: 'analytics', name: 'Analytics', icon: BarChart3 },
  { path: 'upgrade-plan', name: 'Upgrade Plan', icon: Crown },
];
